import React, { Component } from 'react'
import { Table, DatePicker, Button, message } from 'antd'
import moment from 'moment'
import { toServeTime, clickDownload, round } from '../../../../util/index'
import { serviceOfMonth } from '../../../../api/employee'
import { getLastMonth } from '../../../../util/index'
const { RangePicker } = DatePicker

export default class monthTable extends Component {
  state = {
    isloading: false,
    pickerValue: [
      moment(getLastMonth().firstDay, 'YYYY-MM-DD'),
      moment(getLastMonth().firstDay, 'YYYY-MM-DD'),
    ],
    hackValue: null,
    dates: [],
    list: [],
  }

  componentDidMount() {
    this.getDatas()
  }

  getDatas = async () => {
    const sTime = moment(this.state.pickerValue[0])
    const eTime = moment(this.state.pickerValue[1])
    sTime.date(1)
    sTime.startOf('day')
    eTime.add(1, 'month').startOf('month')
    const { status, detail, data } = await serviceOfMonth({
      startTimestamp: sTime.unix(),
      endTimestamp: eTime.unix(),
    })
    this.setState({
      isloading: false,
    })
    if (status != 1) {
      message.error(detail)
      return
    }
    const dataAry = [].concat(data)
    if (dataAry && dataAry.length > 0) {
      const newData = dataAry.map((item) => {
        const { hour, minute, second } = toServeTime(item.duration)
        return {
          employeeId: item.employeeId, //员工ID
          duration: `${hour}小时${minute}分钟`, //总时长
          name: item.name, //员工名称
          amounts: round(item.amounts / 100, 2), // 服务费
          commissions: round(item.commissions / 100, 2), // 分成
          identityType: item.identityType > 1 ? '记分员' : '助教', // 服务（身份）
        }
      })
      this.setState({
        list: newData,
      })
    } else {
      this.setState({
        list: [],
      })
    }
  }

  onChange = (value, dateString) => {
    if (!value) {
      return
    }
    this.setState({
      pickerValue: value,
    })
  }

  onOpenChange = (open) => {
    if (open) {
      this.setState({
        dates: [],
        hackValue: [],
      })
    } else {
      this.setState({
        hackValue: undefined,
      })
    }
  }

  onCalendarChange = (val) => {
    this.setState({
      dates: val,
    })
  }

  disabledDate = (current) => {
    if (!this.state.dates || this.state.dates.length === 0) {
      return false || current >= moment()
    }
    // 控制选择范围6个月内
    const tooLate =
      this.state.dates[0] && current.diff(this.state.dates[0], 'months') > 4
    const tooEarly =
      this.state.dates[1] && this.state.dates[1].diff(current, 'months') > 4
    return tooLate || tooEarly || current >= moment()
  }

  onSearchEvent = () => {
    if (this.state.isloading) {
      return
    }
    this.setState({ isloading: true }, () => {
      this.getDatas()
    })
  }

  render() {
    const { isloading, list, hackValue, pickerValue } = this.state
    const dateString = pickerValue
      ? `${pickerValue[0].format('YYYY-MM-DD')}-${pickerValue[1].format(
          'YYYY-MM-DD'
        )}`
      : moment().format('YYYY-MM-DD')
    const columns = [
      {
        title: '服务员',
        dataIndex: 'name',
      },
      {
        title: '服务',
        dataIndex: 'identityType',
      },
      {
        title: '时长/小时',
        dataIndex: 'duration',
      },
      {
        title: '服务费(元)',
        dataIndex: 'amounts',
      },
      {
        title: '分成(元)',
        dataIndex: 'commissions',
      },
    ]
    return (
      <div>
        <div className="com-table-select-top-view">
          <RangePicker
            disabledDate={this.disabledDate}
            format="YYYY-MM"
            picker="month"
            placeholder={['开始时间', '结束时间']}
            value={hackValue || pickerValue}
            onChange={this.onChange}
            onCalendarChange={this.onCalendarChange}
            onOpenChange={this.onOpenChange}
          />
          <Button
            type="primary"
            className="button-flex-left"
            onClick={this.onSearchEvent}
          >
            查询
          </Button>
          <Button type="default" className="button-flex-left">
            <a
              id="test"
              href={clickDownload(columns, list || [])}
              download={`服务记录月度统计-${dateString}.csv`}
            >
              导出
            </a>
          </Button>
        </div>
        <Table
          rowKey={(record, index) => index}
          loading={isloading}
          bordered
          size="small"
          columns={columns}
          dataSource={list}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubServiceRecord/component/monthTable/monthTable.js